'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2;

import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ANNUAL, MONTHLY } from 'self-service-api/constants/Terms';
import styled from 'styled-components';
import classNames from '../../utils/classNames';
import PriceDisplay from '../common/pricing/PriceDisplay';
import { SLINKY, OBSIDIAN } from 'HubStyleTokens/colors';
import breakpoint from '../../utils/responsiveBreakpoints';
import H6 from 'UIComponents/elements/headings/H6';
const Wrapper = styled.div.withConfig({
  displayName: "PriceDisplaySection__Wrapper",
  componentId: "sc-1ggtova-0"
})(["line-height:initial;"]);
const BillingCaption = styled.div.withConfig({
  displayName: "PriceDisplaySection__BillingCaption",
  componentId: "sc-1ggtova-1"
})(["font-size:13px;font-weight:600;line-height:20px;text-transform:uppercase;", ";"], breakpoint.tablet(_t || (_t = _`
    font-weight: 600;
  `)));
const MonthlyPrice = styled(PriceDisplay).withConfig({
  displayName: "PriceDisplaySection__MonthlyPrice",
  componentId: "sc-1ggtova-2"
})(["font-size:38px;font-weight:bold;", ";"], breakpoint.tablet(_t2 || (_t2 = _`
    font-size: 45px;
  `)));
const CrossedOutPrice = styled(PriceDisplay).withConfig({
  displayName: "PriceDisplaySection__CrossedOutPrice",
  componentId: "sc-1ggtova-3"
})(["text-decoration:line-through;"]);
const PerMonthSubtext = styled.span.withConfig({
  displayName: "PriceDisplaySection__PerMonthSubtext",
  componentId: "sc-1ggtova-4"
})(["font-size:26px;font-weight:600;display:inline-flex;"]);
const StyledPriceText = styled.span.withConfig({
  displayName: "PriceDisplaySection__StyledPriceText",
  componentId: "sc-1ggtova-5"
})(["font-size:18px;font-weight:400;"]);
const BillingTermSubtext = styled.span.withConfig({
  displayName: "PriceDisplaySection__BillingTermSubtext",
  componentId: "sc-1ggtova-6"
})(["display:block;font-size:12px;color:", ";"], SLINKY);
const Bold = styled.span.withConfig({
  displayName: "PriceDisplaySection__Bold",
  componentId: "sc-1ggtova-7"
})(["color:", ";font-weight:600;"], OBSIDIAN);
export const PriceDisplaySection = ({
  annualCostPrice,
  annualListPrice,
  monthlyCostPrice,
  activeCurrencyCode,
  isCurrentPlanSelected = false,
  term,
  costToGetStarted,
  showTotalPriceAsterisk = false,
  showingOnlyAdditionalCost
}) => {
  const showCostToGetStarted = costToGetStarted > 0 && costToGetStarted > (term === ANNUAL ? annualCostPrice : monthlyCostPrice);

  const calculatedPriceDisplay = /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: term && monthlyCostPrice > 0 ? term === MONTHLY ? 'pricingPage.planBuilder.priceDisplay.pricingBilledMonthly_jsx' : 'pricingPage.planBuilder.priceDisplay.pricingBilledAnnually_jsx' : 'pricingPage.planBuilder.priceDisplay.pricingNoBillingTerm_jsx',
    elements: {
      MonthlyPrice,
      PerMonthSubtext,
      BillingTermSubtext,
      AnnualPrice: PriceDisplay,
      Bold,
      // Only show crossed-out original price if list price and cost price are different
      CrossedOutPrice: annualListPrice === annualCostPrice ? () => null : CrossedOutPrice,
      Wrapper
    },
    options: {
      monthlyPriceProps: {
        price: monthlyCostPrice,
        currencyCode: activeCurrencyCode,
        'data-selenium-id': 'plan-builder-monthly-price',
        'data-discounted': annualListPrice > annualCostPrice
      },
      annualPriceProps: {
        price: annualCostPrice,
        currencyCode: activeCurrencyCode,
        'data-selenium-id': !showCostToGetStarted && 'plan-builder-total-price'
      },
      crossedOutPriceProps: {
        price: annualListPrice,
        currencyCode: activeCurrencyCode
      },
      wrapperProps: {
        'data-discounted': annualListPrice > annualCostPrice
      }
    }
  });

  if (isCurrentPlanSelected) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(BillingCaption, {
        className: "p-x-5 m-top-8 m-bottom-5",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.planBuilder.priceDisplay.additionalCost"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "m-y-5",
        children: calculatedPriceDisplay
      })]
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showingOnlyAdditionalCost && /*#__PURE__*/_jsx(H6, {
      className: "m-top-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.planBuilder.priceDisplay.additionalCost"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: classNames(costToGetStarted > 0 && 'm-bottom-5'),
      children: calculatedPriceDisplay
    }), showCostToGetStarted && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(BillingCaption, {
        className: "p-x-5 m-bottom-1",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.planBuilder.priceDisplay.estimatedCost"
        })
      }), /*#__PURE__*/_jsxs(StyledPriceText, {
        children: [/*#__PURE__*/_jsx(PriceDisplay, {
          currencyCode: activeCurrencyCode,
          price: costToGetStarted,
          "data-selenium-id": "plan-builder-total-price"
        }), showTotalPriceAsterisk && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.planBuilder.requiredOnboardingSubtext.asterisk"
        })]
      })]
    })]
  });
};